import { useModel } from "@stem-sims/nexus"
import { Button, Modal } from "react-bootstrap"
import { getReviewGroups } from "shared/routes/reviewRoutes"
import { BeatLoader } from "react-spinners"
import { ReviewGrades, ReviewGradeType } from "shared/types/science35Types"
import { useEffect, useState } from "react"

interface Props {
    show: boolean
    onHide: () => void
    groupIds: string[]
    onSelection: (groupIds: string[]) => Promise<void>
}

const science38Grades: ReviewGradeType[] = [...ReviewGrades]

const SelectReviewGroupsModal = ({ show, onHide, groupIds, onSelection }: Props) => {

    const [selectedGroupIds, setSelectedGroupIds] = useState<string[]>([])

    const { response: reviewGroups, loading } = useModel({
        model: getReviewGroups,
        props: { applyFilter: false, gradeLevels: science38Grades },
    })

    useEffect(() => {
        if (groupIds) setSelectedGroupIds(groupIds)
    }, [groupIds])

    if (loading || !reviewGroups) return <BeatLoader />

    const onSelectGroup = (groupId: string) => {
        if (selectedGroupIds.includes(groupId)) {
            setSelectedGroupIds(selectedGroupIds.filter((id) => id !== groupId))
        } else {
            setSelectedGroupIds([...selectedGroupIds, groupId])
        }
    }

    const onHideModal = () => {
        setSelectedGroupIds([])
        onHide()
    }

    const onSave = async (groupIds: string[]) => {
        await onSelection(groupIds)
        onHideModal()
    }

  return (
    <Modal size="xl" show={show} onHide={onHideModal}>
        <Modal.Header closeButton>
            <div className="d-flex w-100 align-items-center">
                <span>Select Review Groups</span>
                <Button
                    variant="theme"
                    className="ms-auto"
                    onClick={() => onSave(selectedGroupIds)}
                >
                    Save
                </Button>
            </div>
        </Modal.Header>

        <Modal.Body>
            <ul className="list-group text-start h-75 overflow-auto">
                {reviewGroups.map((group, i) => (
                    <li 
                        role="button"
                        className={`list-group-item p-3 ${selectedGroupIds.includes(group.groupId) ? "active" : ""}`} 
                        onClick={() => onSelectGroup(group.groupId)}>{group.name}
                    </li>
                ))}
            </ul>
        </Modal.Body>

        <Modal.Footer>
        </Modal.Footer>
    </Modal>
  )
}

export default SelectReviewGroupsModal
